import React from 'react';
import {
  Autocomplete,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import {
  Edit,
  SimpleForm,
  TextInput,
  Toolbar,
  SaveButton,
  useEditContext,
  AutocompleteInput,
} from 'react-admin';
import BlankImage from '../../assets/images/logo/BlankImage.png';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CustomDeleteButton from './CustomDeleteButton';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  allIndustries,
  getMerchantByID,
  updateSubmerchantRoot,
} from '../../services/Merchant';
import { useState } from 'react';
import { allCities, allCountries, allStates } from '../../services/State';
import { BusinessType } from '../../constants/BusinessType';
import Color from '../layout/color/Color';
import FontSize from '../layout/FontSize';



const backSmallButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: "1px solid ",
  color: Color.Button,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

export const MerchantEdit = (props) => {
  const isLg = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const isMd = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const { id } = useParams();

  const [record, setRecord] = useState(null);
  const [countries, setCountries] = useState(null);
  const [country, setCountry] = useState(null);
  const [states, setStates] = useState([]);
  const [state, setState] = useState(null);
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState(null);
  const [imgPath, setImgPath] = useState(null);
  const [industries, setIndustries] = useState([]);


  useEffect(() => {
    const fetchAPI = async () => {
      try {
        const response = await allIndustries();
        if (response !== null && response !== undefined) setIndustries(response);
      } catch (err) {
        console.log(err);
      }
    }

    fetchAPI();
  }, [])


  const [subMerchantRoot, setSubMerchantRoot] = useState({
    id: 0,
    merchantID: 0,
    submerchantID: 0,
    name: '',
    state: '',
    city: '',
    phone: '',
    email: '',
    address: '',
  });


  useEffect(() => {
    getMerchantByID(parseInt(id))
      .then((result) => {
        if (result !== null) {
          setRecord(result);
          setCountry(result.country);
          setImgPath(result.brc_image_path);
        }
      })
      .catch((errors) => {
        console.log(errors);
      });
  }, [id]);

  useEffect(() => {
    if (record !== null) {
      for (var i = 0; i < record.apollo_submerchant.length; i++) {
        if (
          record.apollo_submerchant[i].submerchantID === 0 &&
          record.apollo_submerchant[i].id !== 0
        ) {
          return setSubMerchantRoot(record.apollo_submerchant[i]);
        }
      }
    }
  }, [record]);

  useEffect(() => {
    allCountries()
      .then((result) => {
        if (result !== null) {
          setCountries(result);
        }
      })
      .catch((errors) => {
        console.log(errors);
      });
  }, []);

  useEffect(() => {
    const fetchAPI = async () => {
      try {
        if (country !== null && country !== '' && country !== undefined) {
          const response = await allStates(country);
          if (response !== null && response !== undefined) setStates(response);
        } else setStates([]);
      } catch (err) {
        console.log(err);
      }
    };

    fetchAPI();
  }, [country]);

  useEffect(() => {
    const fetchAPI = async () => {
      try {
        if (subMerchantRoot.state !== '') {
          const response = await allCities(subMerchantRoot.state);
          if (response !== null && response !== undefined) setCities(response);
        } else setCities([]);
      } catch (err) {
        console.log(err);
      }
    };

    fetchAPI();
  }, [subMerchantRoot.state]);

  useEffect(() => {
    if (states.length > 0 && subMerchantRoot.state !== null) {
      const findState = states.filter((p) => p.id === subMerchantRoot.state);
      setState(findState[0]);
    }
  }, [states]);

  useEffect(() => {
    if (cities.length > 0 && subMerchantRoot.city !== null) {
      const findCity = cities.filter((p) => p.id === subMerchantRoot.city);
      setCity(findCity[0]);
    }
  }, [cities]);

  return (
    subMerchantRoot !== null &&
    countries !== null && (
      <Edit redirect="false" {...props}>
        <SimpleForm
          toolbar={<CustomToolbar submerchantroot={subMerchantRoot} />}
        >
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              mb: 2
            }}
          >
            <Button
              endIcon={<AccountBalanceIcon sx={{ color: Color.Main }} />}
              sx={{ textAlign: 'left', cursor: 'default' }}
              size="medium"
            >
              <Typography variant="h3">Merchant Management</Typography>
            </Button>
            <CustomDeleteButton />
          </Grid>
          <Divider sx={{ width: '100%', mb: 2 }} />
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <CompanyID />
          </Grid>
          <Grid container spacing={2}>
            <Grid item container lg={4} md={6} xs={12}>
              <Grid item xs={12}>
                <AutocompleteInput
                  disabled
                  source="country"
                  fullWidth
                  variant="outlined"
                  label="Country"
                  required
                  value={country}
                  choices={countries}
                />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  disabled
                  source="brand"
                  fullWidth
                  variant="outlined"
                  label="Brand/Trade name"
                />
              </Grid>
              <Grid item xs={12}>
                <AutocompleteInput
                  disabled

                  source="industry"
                  // /                fullWidth
                  variant="outlined"
                  label="Industry"
                  // emptyValue={null}
                  optionText="content"
                  choices={industries}
                />
                {/* <TextInput
                  disabled
                  source="industry"
                  fullWidth
                  variant="outlined"
                  label="Industry"
                /> */}
              </Grid>
              <Grid item xs={12}>
                <AutocompleteInput
                  source="type"
                  fullWidth
                  variant="outlined"
                  label="Type"
                  disabled
                  required
                  choices={BusinessType}
                />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  source="name"
                  fullWidth
                  variant="outlined"
                  label="Legal Name"
                  disabled
                  required
                />
              </Grid>
            </Grid>
            <Grid item container lg={4} md={6} xs={12} spacing={isMd ? 3 : 0}>
              <Grid item xs={12}>
                <Autocomplete
                  isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                  }
                  getOptionLabel={(option) => option?.name}
                  fullWidth
                  disabled
                  renderInput={(params) => (
                    <TextField {...params} label="State" />
                  )}
                  options={states}
                  value={state}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                  }
                  getOptionLabel={(option) => option?.name}
                  fullWidth
                  disabled
                  renderInput={(params) => (
                    <TextField {...params} label="City" />
                  )}
                  options={cities}
                  value={city}
                  size="medium"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  disabled
                  value={subMerchantRoot?.address}
                  label="Address"
                  fullWidth
                  onChange={(e) =>
                    setSubMerchantRoot({
                      ...subMerchantRoot,
                      address: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={subMerchantRoot?.phone}
                  label="Phone"
                  fullWidth
                  onChange={(e) =>
                    setSubMerchantRoot({
                      ...subMerchantRoot,
                      phone: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={subMerchantRoot?.email}
                  label="Email"
                  fullWidth
                  onChange={(e) =>
                    setSubMerchantRoot({
                      ...subMerchantRoot,
                      email: e.target.value,
                    })
                  }
                />
              </Grid>
            </Grid>
            <Grid
              item
              container
              lg={4}
              md={12}
              xs={12}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Grid item xs={12} textAlign="center">
                <img
                  alt="default"
                  src={imgPath === null ? BlankImage : imgPath}
                  style={{
                    width: isLg ? '80%' : isMd ? '40%' : '80%',
                    aspectRatio: 1,
                    borderRadius: '4px'
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </SimpleForm>
      </Edit>
    )
  );
};

const CompanyID = () => {
  const { record } = useEditContext();

  return (
    <Typography variant="h5" fontWeight="bold" pb="1rem">
      Company ID: {record.brc_number}
    </Typography>
  );
};

const CustomToolbar = (props) => {
  const { submerchantroot } = props;
  const handleUpdateMerChant = () => {
    updateSubmerchantRoot(submerchantroot)
      .then((result) => {
        //TODO
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Toolbar
      {...props}
      sx={{
        display: 'flex',
        justifyContent: 'end',
        textAlign: 'right',
      }}
    >
      <SaveButton onClick={handleUpdateMerChant} alwaysEnable sx={backSmallButton} />
    </Toolbar>
  );
};
